
import TIM from 'tim-js-sdk';
import COS from 'cos-js-sdk-v5';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import {
  importAccount,
  indexLoad,
  validateStatus,
  custerInfo,
  queryMessageRecordDetail,
  validateInputStatus,
  productInfo
} from '@/services/http';
import bigImg from '@/components/big-img/big-img.vue';
import {
  emojiList, emojis, uncodeUtf16, utf16toEntities
} from '@/emoji/index';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    bigImg
  },
  filters: {
    calcPrice(val: any) {
      if (!val) {
        return;
      }
      // eslint-disable-next-line consistent-return
      return val.toString().split('.')[0];
    },
    calcPrice2(val: any) {
      if (!val) {
        return;
      }
      // eslint-disable-next-line consistent-return
      return val.toString().split('.')[1] ? val.toString().split('.')[1] : '00';
    },
    formatDate(time: any) {
      if (!time) {
        return;
      }
      // eslint-disable-next-line consistent-return
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    }
  }
})
export default class extends Vue {
  changeIm: boolean = false

  tim: any = {}

  robotObj: any = {}

  scrollHeight: any = ''

  currentId: number = -1

  imgSrc: string = ''

  newTime: any = 0 // 最新时间

  newSequence: any = 0 // 最新时间

  isOnce: number = 0

  userInfo: any = {} // 用户信息

  noMore: boolean = false // 历史记录没有更多

  lastEditRange: number = 0 // 聊天框最后光标位置

  message: string = ''

  openEmojis: boolean = false // 打开表情

  isOver: boolean = false // 是否可发送

  flagNum: number = 0

  emojiList: any = emojiList() // 所有表情库

  emojis: any = emojis() // 去重后的表情库

  conversationInfo: any = {} // 当前会话信息

  messageList: any[] = [] // 消息列表

  robot: any = '' // 机器人

  custerInfo: any = {} // 客服信息

  nextReqMessageID: any = '' // 用于腾讯IM续拉，分页续拉时需传入该字段

  isMoreMessage: boolean = true // 是否有更多当前消息

  openHistory: boolean = false // 是否打开历史记录

  loading: boolean = true // 是否加载完

  isCoding: boolean = false // 是否加载完

  goodsInfo: any = {} // 是否加载完

  showImg: boolean = false //

  currentPage: number = 0 // 当前页数

  currentLen: number = 0 // 当前长度

  ready: boolean = false

  isSearch: boolean = false

  isDrop: boolean = false // 移动状态的判断鼠标按下才能移动

  listQuery: any = {
    pageNo: 1,
    pageSize: 15,
    keyword: '',
    companyId: 1
  }

  historyList: Array<object> = []

  created() {
    (window as any).openUrl = (url: any) => {
      window.open(url, '_blank');
    };
    this.$emit('passpicker', this);
    // this.initData();
  }

  replaceSrc(txt: any) {
    if (txt.indexOf('<img') !== -1) {
      return txt;
    }
    const reg = /(((https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;
    const result = txt.replace(
      reg,
      (item: any) => `<span onclick="openUrl('${item}')" style="color:#0074F0;cursor:pointer;">${item}</span>`
    );

    return result;
  }

  initData() {
    if (this.$route.name === 'details') {
      productInfo({
        productId: this.$route.query.id
      }).then((res: any) => {
        this.goodsInfo = res.data.data;
        this.getImportAccount();
      });
    } else {
      this.getImportAccount();
    }
    this.openDrod();
  }

  // 开始监听拖拽
  openDrod() {
    setTimeout(() => {
      const box: any | null = document.querySelectorAll('.im .drop-header'); // 获取元素
      let x: any = '';
      let y: any = ''; // 存储div的坐标
      box.forEach((element: any) => {
        element.addEventListener('mousedown', (e: any) => {
          // eslint-disable-next-line no-var
          var e1 = e || window.event; // 要用event这个对象来获取鼠标的位置
          x = e1.clientX - element.parentNode.parentNode.offsetLeft;
          y = e1.clientY - element.parentNode.parentNode.offsetTop;
          this.isDrop = true; // 设为true表示可以移动
        });
        document.onmousemove = (e: any) => {
          // 是否为可移动状态
          if (this.isDrop) {
            const e1 = e || window.event;
            const moveX = e1.clientX - x; // 得到距离左边移动距离
            const moveY = e1.clientY - y; // 得到距离上边移动距离

            // eslint-disable-next-line no-param-reassign
            element.parentNode.parentNode.style.left = `${moveX}px`;
            // eslint-disable-next-line no-param-reassign
            element.parentNode.parentNode.style.top = `${moveY}px`;
            // eslint-disable-next-line no-param-reassign
            element.parentNode.parentNode.style.right = 'auto';
          }
        };
        document.onmouseup = () => {
          this.isDrop = false; // 设置为false不可移动
        };
      });
    }, 0);
  }

  emojisBlur() {
    setTimeout(() => {
      this.openEmojis = false;
      (this as any).$refs.emojisFocus.blur();
    }, 200);
  }

  // 发送给机器人
  sendRobot(item: any) {
    const initMessage = this.tim.createCustomMessage({
      to: this.conversationInfo.userProfile.userID,
      conversationType: TIM.TYPES.CONV_C2C,
      payload: {
        data: JSON.stringify({
          itemType: 0,
          itemData: [
            {
              itemId: item.itemId,
              itemTitle: item.itemTitle,
              itemValue: item.itemValue
            }
          ],
          itemText: ''
        }),
        description: '',
        extension: ''
      }
    });
    // 2. 发送消息
    const promise = this.tim.sendMessage(initMessage);
    promise
      .then((imResponse: any) => {
        // eslint-disable-next-line no-param-reassign
        imResponse.data.message.payload.text = item.itemTitle;
        this.messageList.push(imResponse.data.message); // 更新消息列表
        this.message = '';
        this.$nextTick(() => {
          (this as any).$refs.content.scrollTop = (this as any).$refs.content.scrollHeight - (this as any).$refs.content.clientHeight; // 滚动条位置设置在底部
        });
      })
      .catch(() => {}); // 发送失败
  }

  // 清除搜索文字
  private clearSearch() {
    this.listQuery.keyword = '';
    this.listQuery.pageNo = 1;
    this.isSearch = false;
    // (this.$refs.historyContent as any).scrollTop = 0;
    this.getHistory();
  }

  // 点击搜索
  private btnSearch() {
    if (this.listQuery.keyword.length <= 0) {
      this.isSearch = false;
    } else {
      this.isSearch = true;
    }
    this.listQuery.pageNo = 1;

    this.historyList = [];
    // (this as any).$refs.historyContent.scrollTop = 0;
    this.getHistory();
  }

  openEmojisDia() {
    if (!this.isOver) {
      this.openEmojis = !this.openEmojis;

      if (this.openEmojis) {
        (this as any).$refs.emojisFocus.focus();
      }
    }
  }

  viewImg() {
    this.showImg = false;
  }

  // 打开历史记录
  openSelfHistory() {
    // document.body.clientWidth
    this.isSearch = false;
    this.openHistory = !this.openHistory;
    if (this.openHistory) {
      const imBox: any | null = document.querySelector('.im');
      // eslint-disable-next-line radix
      if (document.body.clientWidth - parseInt(imBox.style.left) < 986) {
        imBox.style.left = `${document.body.clientWidth - 986}px`;
      }
    }
    if (this.openHistory) {
      this.listQuery.pageNo = 1;
      // (this as any).$refs.historyContent.scrollTop = 0;
      this.getHistory();
    }
  }

  // 获取历史记录
  private getHistory() {
    this.loading = true;
    queryMessageRecordDetail(this.listQuery).then((res: any) => {
      let tempData: any = [];
      if (this.isSearch) {
        tempData = this.formatHistoryList(res.data.data.list, 'unshift');
      } else {
        tempData = this.formatHistoryList(res.data.data.list, 'push');
      }

      if (this.listQuery.pageNo === 1) {
        this.historyList = tempData;
      } else if (!this.isSearch) {
        this.historyList = [...tempData, ...this.historyList];
      } else {
        this.historyList = [...this.historyList, ...tempData];
      }
      if (res.data.data.list.length <= 0) {
        this.noMore = true;
      }
      setTimeout(() => {
        const timPics = document.querySelectorAll('.tim-pic');
        timPics.forEach((element: any) => {
          // eslint-disable-next-line no-shadow
          if (element.getAttribute('islazy') === '1') {
            element.setAttribute('src', element.getAttribute('z-src'));
          }
          element.addEventListener('click', (e: any) => {
            this.showImg = true;
            // eslint-disable-next-line prefer-destructuring
            this.imgSrc = e.currentTarget.src.split('?imageView')[0];
          });
        });
      }, 0);
      setTimeout(() => {
        if ((this as any).$refs.historyContent) {
          if (this.listQuery.pageNo === 1 && !this.isSearch) {
            (this as any).$refs.historyContent.scrollTop = (this as any).$refs.historyContent.clientHeight
              + (this as any).$refs.historyContent.scrollHeight; // 滚动条位置设置在底部
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.historyList.length > this.listQuery.pageSize) {
              (this as any).$refs.historyContent.scrollTop = (
                this as any
              ).$refs.historyContent.clientHeight;
            } else {
              (this as any).$refs.historyContent.scrollTop = 0;
            } // 滚动条位置设置在底部
          }
        }
        this.loading = false;
        this.listQuery.pageNo += 1;
      }, 200);
    });
  }

  private openInput() {
    if (!this.isOver) {
      (this.$refs.imagePic as any).click();
    }
  }

  // 2. 创建消息实例，接口返回的实例可以上屏
  private consultGoods() {
    const message = this.tim.createCustomMessage({
      to: this.conversationInfo.userProfile.userID,
      conversationType: TIM.TYPES.CONV_C2C,
      // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
      // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
      // priority: TIM.TYPES.MSG_PRIORITY_HIGH,
      payload: {
        data: JSON.stringify({
          name: this.goodsInfo.productName,
          url: this.goodsInfo.listImagePath.cdnFilePathPc,
          price:
            this.goodsInfo.lowestPrice.split(',')[0] === this.goodsInfo.lowestPrice.split(',')[1]
              ? this.goodsInfo.lowestPrice.split(',')[0]
              : this.goodsInfo.lowestPrice,
          id: this.$route.query.id
        }), // 用于标识该消息是骰子类型消息
        description: 'goodsInfo',
        extension: ''
      }
    });
    // 3. 发送消息
    const promise = this.tim.sendMessage(message);
    promise
      .then((imResponse: any) => {
        // 发送成功
        // eslint-disable-next-line no-param-reassign
        imResponse.data.message.type = 'goodsInfo';
        // eslint-disable-next-line no-param-reassign
        imResponse.data.message.payload = JSON.parse(imResponse.data.message.payload.data);
        this.messageList.push(imResponse.data.message); // 更新消息列表
        this.$nextTick(() => {
          (this as any).$refs.content.scrollTop = (this as any).$refs.content.scrollHeight - (this as any).$refs.content.clientHeight; // 滚动条位置设置在底部
        });
      })
      .catch(() => {
        // 发送失败
      });
  }

  private historyLoad() {
    if (this.isDrop) {
      return;
    }
    const { scrollHeight } = this.$refs.historyContent as any;
    const { scrollTop } = this.$refs.historyContent as any;
    const { clientHeight } = this.$refs.historyContent as any;
    if (
      scrollHeight === scrollTop + clientHeight
      && !this.loading
      && this.isSearch
      && this.historyList.length >= 10
    ) {
      this.getHistory();
    } else if (
      scrollTop === 0
      && !this.loading
      && !this.isSearch
      && this.historyList.length >= 10
    ) {
      this.getHistory();
    }
  }

  // 选择表情
  selectEmojis(item: any) {
    this.openEmojis = false;
    const html = `<img class="emoji-img" src="${item.src}" data-src="emoji" emoji-text="${item.text}">`;
    if ((this.$refs.message as any).innerHTML === '') {
      // (this.$refs.message as any).innerHTML = html;
      this.isCoding = true;
      this.setRange(html);
    } else this.setRange(html); // 表情插到输入框最后一次焦点后面
  }

  public initTim() {
    const options = {
      SDKAppID:
        process.env.VUE_APP_BASE_URL === 'https://mapi.ctaiot.com' ? 1400386549 : 1400428151 // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
    };
    // 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
    const tim = TIM.create(options); // SDK 实例通常用 tim 表示

    // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
    tim.setLogLevel(1); // 普通级别，日志量较多，接入时建议使用
    // tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
    // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
    tim.on(TIM.EVENT.SDK_READY, this.SDK_READY);

    // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
    tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.MESSAGE_RECEIVED);

    // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
    tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, this.CONVERSATION_LIST_UPDATED);
    // 注册 COS SDK 插件
    tim.registerPlugin({ 'cos-js-sdk': COS });
    return tim;
  }

  // // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
  // MESSAGE_RECEIVED(event: any) {
  //   const receiveMessage = event.data.map(async (item: any) => {
  //     // 格式化自定义消息
  //     const mes: any = event.data[0];
  //     if (mes.conversationID === 'C2Cadmin') {
  //       this.currentPage = 0;
  //       if (mes.payload.data) {
  //         const text = JSON.parse(mes.payload.data);
  //         mes.payload = { text: text.itemText };
  //         mes.flow = 'status';
  //         if (text.itemType === 4 || text.itemType === 5) {
  //           // 会话已被客服接起
  //           this.custerInfo.conversationID = `C2C${text.itemData[0].itemId}`;
  //           // this.custerInfo.custNickName = text.itemData[0].custNickName;
  //           // this.custerInfo.custHeadImg = text.itemData[0].custImg;
  //           this.conversationInfo = {
  //             conversationID: `C2C${text.itemData[0].itemId}`,
  //             userProfile: { userID: text.itemData[0].itemId }
  //           };
  //           await this.getCusterInfo();
  //           this.getMessageList();
  //           this.isOver = false;
  //           // this.currentPage = 0;
  //         }
  //       }
  //     } else if (item.type === 'TIMCustomElem') {
  //       // 格式化自定义消息

  //       // eslint-disable-next-line no-param-reassign
  //       // item.payload = { text: text.itemText };
  //       // eslint-disable-next-line no-param-reassign
  //       item.flow = 'status';
  //       if (item.payload.data) {
  //         const text = JSON.parse(item.payload.data);
  //         if (text.itemType && text.itemType === 6) {
  //           this.outLogin(); this.isOver = true;
  //         } else if (text.itemType && text.itemType === 5) {
  //           this.messageList = [];
  //         }
  //         // eslint-disable-next-line no-param-reassign
  //         item.payload = { text: text.itemText };
  //       }
  //     } else if (item.type === 'TIMImageElem') {
  //       // 格式化图片消息
  //       const url = item.payload.imageInfoArray[0].imageUrl.split(
  //         '?imageView'
  //       )[0];
  //         // eslint-disable-next-line no-param-reassign
  //       item.payload = { text: `<img class="tim-pic" z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">` };
  //     } else if (item.type !== 'TIMImageElem') {
  //       // 解析表情转本地库表情
  //       for (let j = 0; j < this.emojiList.length; j += 1) {
  //         const reg = new RegExp(this.emojiList[j].code, 'g');
  //         // eslint-disable-next-line no-param-reassign
  //         item.payload.text = utf16toEntities(item.payload.text).replace(
  //           reg,
  //           `<img class="emoji-img" src="${this.emojiList[j].src}">`
  //         );
  //       }
  //     }
  //     return item;
  //   })[0];
  //   this.messageList.push(receiveMessage);
  //   setTimeout(() => {
  //     const timPics = document.querySelectorAll('.tim-pic');
  //     timPics.forEach((element:any) => {
  //       // eslint-disable-next-line no-shadow
  //       if (element.getAttribute('islazy') === '1') {
  //         element.setAttribute('src', element.getAttribute('z-src'));
  //       }
  //       element.addEventListener('click', (e:any) => {
  //         this.showImg = true;
  //         // eslint-disable-next-line prefer-destructuring
  //         this.imgSrc = e.currentTarget.src.split('?imageView')[0];
  //       });
  //     });
  //   }, 0);
  //   this.$nextTick(() => {
  //     setTimeout(() => {
  //       if ((this as any).$refs.content) {
  //         (this as any).$refs.content.scrollTop = (this as any).$refs.content.scrollHeight
  //           - (this as any).$refs.content.clientHeight; // 滚动条位置设置在底部
  //       }
  //     }, 200);
  //     this.tim.setMessageRead({
  //       conversationID: this.conversationInfo.conversationID
  //     });
  //   });
  // }

  // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
  async MESSAGE_RECEIVED(event: any) {
    event.data.forEach(async (mes: any) => {
      if (this.newTime === mes.time && mes.sequence === this.newSequence) {
        return;
      }
      this.newTime = mes.time;
      this.newSequence = mes.sequence;
      if (mes.conversationID === 'C2Cadmin' || mes.conversationID === 'C2CmallAdmin') {
        this.currentPage = 0;
        if (mes.payload.data) {
          const text = JSON.parse(mes.payload.data);
          if (text.itemType === 1 || text.itemType === 0) {
            const temp: any = JSON.parse(mes.payload.data);
            this.messageList.push({
              flow: 'in',
              payload: { text: temp.itemData[0].itemValue }
            });
          } else if (text.itemType === 4 || text.itemType === 5) {
            // 会话已被客服接起
            this.custerInfo.conversationID = `C2C${text.itemData[0].itemId}`;
            // this.custerInfo.custNickName = text.itemData[0].custNickName;
            // this.custerInfo.custHeadImg = text.itemData[0].custImg;
            this.changeIm = true;
            this.conversationInfo = {
              conversationID: `C2C${text.itemData[0].itemId}`,
              userProfile: { userID: text.itemData[0].itemId }
            };
            await this.getCusterInfo();
            this.getMessageList(text.itemType === 5);
            this.isOver = false;
            // this.currentPage = 0;
          } else if (text.itemType === -1) {
            // this.robotObj = {
            //   payload: text,
            //   type: -1,
            //   flow: 'in'
            // };
          } else if (text.itemType === 7 || text.itemType === 6) {
            // eslint-disable-next-line no-param-reassign
            mes.payload = { text: text.itemText };
            // eslint-disable-next-line no-param-reassign
            mes.flow = 'status';
            this.isOver = true;
            this.messageList = [];
            this.messageList.push(mes);
          }
        }
      } else {
        // const res: any = await validateStatus(); // 是否在会话中
        // if (
        //   res
        //   && res.data
        //   && res.data.code === 100
        //   && !res.data.data.messageStatus
        // ) {
        //   // 在会话中，获取客服信息
        //   this.conversationInfo.conversationID = `C2C${res.data.data.custAccount}`;
        //   this.custerInfo.conversationID = `C2C${res.data.data.custAccount}`;
        //   this.custerInfo.custNickName = res.data.data.custNickName;
        //   this.custerInfo.custHeadImg = res.data.data.custHeadImg;
        // }
        // if (this.currentPage === 0) {
        //   this.getMessageList(true, true);
        // }

        this.isOver = false;
        if (mes.type === 'TIMCustomElem') {
          // 格式化自定义消息
          // eslint-disable-next-line no-param-reassign
          mes.flow = 'date';
        } else if (mes.type === 'TIMImageElem') {
          // 格式化图片消息
          const url = mes.payload.imageInfoArray[0].imageUrl.split('?imageView')[0];
          // eslint-disable-next-line no-param-reassign
          mes.payload = {
            text: `<img class="tim-pic" z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">`
          };
        } else if (mes.type !== 'TIMImageElem') {
          // 解析表情转本地库表情
          for (let j = 0; j < this.emojiList.length; j += 1) {
            const reg = new RegExp(this.emojiList[j].code, 'g');
            // eslint-disable-next-line no-param-reassign
            mes.payload.text = utf16toEntities(mes.payload.text).replace(
              reg,
              `<img class="emoji-img" src="${this.emojiList[j].src}">`
            );
          }
        }
        // for (let i = 0; i < this.messageList.length; i += 1) {
        //   if (this.messageList[i].payload.text === '会话转接中...') {
        //     this.messageList[i].payload.text = '会话转接成功';
        //     break;
        //   }
        // }
        if (mes.payload.description === 'goodsInfo') {
          // 格式化自定义消息
          const goodsData = JSON.parse(mes.payload.data);
          // eslint-disable-next-line no-param-reassign
          mes.payload = goodsData;
          // eslint-disable-next-line no-param-reassign
          mes.type = 'goodsInfo';
          // eslint-disable-next-line no-param-reassign
          mes.flow = 'in';
        }
        this.messageList.push(mes);
        setTimeout(() => {
          const timPics = document.querySelectorAll('.tim-pic');
          timPics.forEach((element: any) => {
            // eslint-disable-next-line no-shadow
            if (element.getAttribute('islazy') === '1') {
              element.setAttribute('islazy', 0);
              element.setAttribute('src', element.getAttribute('z-src'));
            }
            element.addEventListener('click', (e: any) => {
              this.showImg = true;
              // eslint-disable-next-line prefer-destructuring
              this.imgSrc = e.currentTarget.src.split('?imageView')[0];
            });
          });
        }, 0);
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if ((this as any).$refs.content) {
            (this as any).$refs.content.scrollTop = (this as any).$refs.content.scrollHeight - (this as any).$refs.content.clientHeight;
          } // 滚动条位置设置在底部
        }, 300);
      });
    });
  }

  private closeIm() {
    this.$emit('closeIm');
  }

  // 发送图片消息
  async sendImageMessage(e: any) {
    const file = e.target.files[0];
    if (file.size / 1024 > 1024 * 10) {
      (this as any).$toast.text('图片大小不能超过 10M');
      return;
    }
    const url = window.URL.createObjectURL(file);
    const mes = {
      flow: 'out',
      type: 'TIMImageElem',
      payload: { text: `<img class="tim-pic"  src="${url}" islazy="0" >` }
    };
    // mes.payload = { text: `<img class="tim-pic"  z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">` };
    this.messageList.push(mes);

    setTimeout(() => {
      (this as any).$refs.content.scrollTop = (this as any).$refs.content.scrollHeight + (this as any).$refs.content.clientHeight;
    }, 100);
    // 1. 创建消息实例，接口返回的实例可以上屏
    const message = this.tim.createImageMessage({
      to: this.conversationInfo.userProfile.userID,
      conversationType: TIM.TYPES.CONV_C2C,
      payload: { file }
      // onProgress: event => {}
    });
    // 2. 发送图片消息
    const promise = this.tim.sendMessage(message);
    promise
      .then(() => {
        // 发送成功-->格式化图片消息
        // const mes = imResponse.data.message;
        // const url = mes.payload.imageInfoArray[0].imageUrl.split(
        //   '?imageView'
        // )[0];
        // mes.payload = { text: `<img class="tim-pic"  z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">` };
        // this.messageList.push(mes);
        // setTimeout(() => {
        //   const timPics = document.querySelectorAll('.tim-pic');
        //   timPics.forEach((element:any) => {
        //     if (element.getAttribute('islazy') === '1') {
        //       element.setAttribute('src', element.getAttribute('z-src'));
        //     }
        //     // eslint-disable-next-line no-shadow
        //     element.addEventListener('click', (e:any) => {
        //       this.showImg = true;
        //       // eslint-disable-next-line prefer-destructuring
        //       this.imgSrc = e.currentTarget.src.split('?imageView')[0];
        //     });
        //   });
        // }, 0);
        // setTimeout(() => {
        //   (this.$refs
        //     .content as any).scrollTop = (this as any).$refs.content.scrollHeight;
        // }, 0);
      })
      .catch(() => {}); // 发送失败
    if (this.$refs.imgFile) (this as any).$refs.imgFile.value = '';
  }

  handleKeyCodeUp() {
    if ((this.$refs.message as any).innerHTML.length > 0) {
      this.isCoding = true;
    } else {
      this.isCoding = false;
    }
    this.getEndRange();
    // if (event.ctrlKey && event.keyCode == 86) {
    // // 粘贴过滤非img为emoji图片以外所有标签
    // const regImg = /!<[^>]*>/g
    // // const regImg = /<[img].*?src=[\'|\"]((?!img\/).*?(?:[\.png]))[\'|\"].*?[\/]?>/ig
    // this.$refs.message.innerHTML = this.$refs.message.innerText
    // }
  }

  pasteVal() {}

  // 获取输入框最后光标位置
  getEndRange() {
    if ((this as any).$refs.message.innerHTML.length <= 0) {
      this.isCoding = false;
    }
    this.lastEditRange = (window as any).getSelection().getRangeAt(0);
  }

  // 跳转商品详情
  private toDetailUrl(id: any) {
    window.open(`/details?id=${id}`, '_blank');
  }

  // 发送消息键盘监听（按Enter键发送，按Ctrl+Enter键换行）
  handleKeyCodeDown(event: any) {
    if (event.ctrlKey && event.keyCode === 13) {
      this.setRange('<br><br>');
    } else if (event.keyCode === 13) {
      this.message = (this.$refs.message as any).innerHTML;
      this.sendMessage();
      event.preventDefault();
    }
  }

  // 在当前光标后添加内容
  setRange(html: any) {
    const el = this.$refs.message;
    let range;
    let node;
    if (!(el as any).hasfocus) (el as any).focus(); // 输入框获取焦点
    if (window.getSelection && (window as any).getSelection().getRangeAt) {
      range = this.lastEditRange ? this.lastEditRange : (window as any).getSelection().getRangeAt(0);
      range.collapse(false);
      node = range.createContextualFragment(html);
      const c = node.lastChild;
      range.insertNode(node);
      if (c) {
        range.setEndAfter(c);
        range.setStartAfter(c);
      }
      const j = (window as any).getSelection();
      j.removeAllRanges();
      j.addRange(range);
    } else if ((document as any).selection && (document as any).selection.createRange) {
      (document as any).selection.createRange().pasteHTML(html);
    }
  }

  private async inputDiv(e: any) {
    if (e.inputType === 'insertParagraph') {
      this.sendMessage();
    }
  }

  // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
  SDK_READY() {
    if (this.ready) return;
    this.ready = true; // 同步完毕-->获取最新会话列表
    setTimeout(async () => {
      const res: any = await validateStatus({ companyId: 1 }); // 是否在会话中
      if (res && res.data && res.data.code === 100 && res.data.data.messageStatus) {
        // 不在会话中，分配客服并获取客服信息，无客服在线则不拉取消息列表
        const service: any = await indexLoad({ companyId: 1 });
        if (service && service.data && service.data.code === 100 && service.data.data) {
          if (service.data.data) {
            // 当前有客服在线
            this.custerInfo.conversationID = `C2C${service.data.data.custAccount}`;
            this.custerInfo.custNickName = service.data.data.custNickName;
            this.custerInfo.custHeadImg = service.data.data.custHeadImg;
            this.conversationInfo = {
              conversationID: `C2C${service.data.data.custAccount}`,
              userProfile: { userID: service.data.data.custAccount }
            };
            // 根据客服信息筛选出对应会话列表
            // eslint-disable-next-line prefer-destructuring
            // this.conversationInfo = this.conversationList.filter(
            //   e => e.conversationID === this.custerInfo.conversationID,
            // )[0];
            if (this.conversationInfo.conversationID) {
              this.getMessageList(false);
            } // 获取消息列表
            this.isOver = false;
          }
        }
      } else if (res && res.data && res.data.code === 100 && !res.data.data.messageStatus) {
        // 在会话中，获取客服信息
        this.custerInfo.conversationID = `C2C${res.data.data.custAccount}`;
        this.custerInfo.custNickName = res.data.data.custNickName;
        this.custerInfo.custHeadImg = res.data.data.custHeadImg;

        this.conversationInfo.conversationID = `C2C${res.data.data.custAccount}`;
        this.conversationInfo.userProfile = {
          userID: res.data.data.custAccount
        };
        // 根据客服信息筛选出对应会话列表
        // eslint-disable-next-line prefer-destructuring
        // this.conversationInfo = this.conversationList.filter(e => e.conversationID === this.custerInfo.conversationID)[0];
        if (this.conversationInfo.conversationID) {
          this.getMessageList(false); // 获取消息列表
          this.isOver = false;
        }
      }
      this.loading = false;
    }, 200);
  }

  async getCusterInfo() {
    const res: any = await custerInfo({
      custAccount: this.conversationInfo.userProfile.userID
    });
    if (res && res.data && res.data.code === 100 && res.data.data) {
      res.data.data.custNickName = res.data.data.custer.workNo;
      res.data.data.custHeadImg = res.data.data.faceUrlImg;
      this.custerInfo = res.data.data;
    }
  }

  /**
   * 格式化列表（自定义、图片、表情）
   * @list 格式化的列表
   * @insert 数组函数（push、unshift）
   */
  formatList(list: any, insert: any) {
    const newList: any = [];
    const tempList: any = list;
    for (let i = 0; i < list.length; i += 1) {
      if (
        tempList[i].type === 'TIMCustomElem'
        && list[i].payload.data
        && list[i].payload.description !== 'goodsInfo'
      ) {
        // 格式化自定义消息
        const data = JSON.parse(list[i].payload.data);
        if (
          data.itemType === 7
          || data.itemType === 0
          || data.itemType === 1
          || data.itemType === -1
        ) {
          if (data.itemType === -1) {
            tempList[i].flow = 'in';
          }
          this.isOver = true;
        } else {
          tempList[i].flow = 'status';
        }
        let text = '';
        if (data.itemType === -1) {
          text = JSON.parse(tempList[i].payload.data);
          tempList[i].type = -1;
          tempList[i].payload = text;
        } else if (data.itemData && data.itemData.length > 0) {
          if (list[i].flow === 'out') {
            text = data.itemData[0].itemTitle;
          } else {
            text = data.itemData[0].itemValue;
          }
        } else {
          text = data.itemText;
        }
        if (data.itemType !== -1) {
          tempList[i].payload = { text };
        }
      } else if (list[i].payload.description === 'goodsInfo') {
        // 格式化自定义消息
        const text = JSON.parse(list[i].payload.data);
        // eslint-disable-next-line no-param-reassign
        tempList[i].payload = text;
        tempList[i].type = 'goodsInfo';
        // eslint-disable-next-line no-param-reassign
        tempList[i].flow = list[i].flow;
      } else if (tempList[i].type === 'TIMImageElem') {
        // 格式化图片消息
        const url = tempList[i].payload.imageInfoArray
          ? tempList[i].payload.imageInfoArray[0].imageUrl
          : tempList[i].payload.text;
        // eslint-disable-next-line no-param-reassign
        // eslint-disable-next-line prefer-destructuring
        tempList[
          i
        ].payload.text = `<img class="tim-pic"  z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">`;
      }

      // 解析表情转本地库表情
      if (list[i].type !== 'TIMImageElem') {
        for (let j = 0; j < this.emojiList.length; j += 1) {
          const reg = new RegExp(this.emojiList[j].code, 'g');
          // eslint-disable-next-line no-param-reassign
          // eslint-disable-next-line import/no-dynamic-require
          tempList[i].payload.text = utf16toEntities(tempList[i].payload.text).replace(
            reg,
            `<img class="emoji-img" src="${this.emojiList[j].src}">`
          );
        }
      }
      newList[insert](tempList[i]);
    }
    return newList;
  }

  /**
   * 格式化列表（自定义、图片、表情）
   * @list 格式化的列表
   * @insert 数组函数（push、unshift）
   */
  formatHistoryList(list: any, insert: any) {
    const newList: any = [];
    const tempList: any = list;
    for (let i = 0; i < list.length; i += 1) {
      if (
        tempList[i].type === 'TIMCustomElem'
        && list[i].payload.data
        && list[i].payload.description !== 'goodsInfo'
      ) {
        // 格式化自定义消息
        const text = JSON.parse(list[i].payload.data).itemText;
        // eslint-disable-next-line no-param-reassign
        tempList[i].payload = { text };
        // eslint-disable-next-line no-param-reassign
        tempList[i].flow = 'status';
      } else if (list[i].payload.description === 'goodsInfo') {
        // 格式化自定义消息
        const text = JSON.parse(list[i].payload.data);
        // eslint-disable-next-line no-param-reassign
        tempList[i].payload = { text };
        tempList[i].type = 'goodsInfo';
        // eslint-disable-next-line no-param-reassign
        tempList[i].flow = 'status';
      } else if (tempList[i].type === 'TIMImageElem') {
        // 格式化图片消息
        const url = tempList[i].payload.text;
        // eslint-disable-next-line no-param-reassign
        // eslint-disable-next-line prefer-destructuring
        tempList[
          i
        ].payload.text = `<img class="tim-pic" z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">`;
      }
      // 解析表情转本地库表情
      if (list[i].type !== 'TIMImageElem') {
        for (let j = 0; j < this.emojiList.length; j += 1) {
          const reg = new RegExp(this.emojiList[j].code, 'g');
          // eslint-disable-next-line no-param-reassign
          // eslint-disable-next-line import/no-dynamic-require
          tempList[i].payload.text = utf16toEntities(tempList[i].payload.text).replace(
            reg,
            `<img class="emoji-img" src="${this.emojiList[j].src}">`
          );
        }
      }
      newList[insert](tempList[i]);
    }
    return newList;
  }

  // 判断是否获取焦点
  private async calcInput() {
    this.isCoding = true;
  }

  // 向上滚动获取更多消息列表
  async load() {
    if (this.isDrop) {
      return;
    }
    if ((this as any).$refs.content.scrollHeight <= (this as any).$refs.content.clientHeight) {
      return;
    }
    if (this.isMoreMessage && (this as any).$refs.content.scrollTop === 0) {
      this.scrollHeight = (this as any).$refs.content.scrollHeight;
      const res = await this.tim.getMessageList({
        conversationID: this.conversationInfo.conversationID,
        nextReqMessageID: this.nextReqMessageID,
        count: 15
      });
      if (res && res.code === 0 && res.data) {
        this.currentPage = res.data.nextReqMessageID.split('-')[res.data.nextReqMessageID.split('-').length - 1];
        this.nextReqMessageID = res.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段
        this.isMoreMessage = !res.data.isCompleted; // 表示是否已经拉完所有消息
        const list: any[] = [];
        res.data.messageList.forEach((item: any) => {
          list.unshift(item);
        });
        this.messageList = this.formatList(list, 'unshift').concat(this.messageList);

        setTimeout(() => {
          const timPics = document.querySelectorAll('.tim-pic');

          timPics.forEach((element: any) => {
            if (element.getAttribute('islazy') === '1') {
              element.setAttribute('src', element.getAttribute('z-src'));
            }
            // eslint-disable-next-line no-shadow
            element.addEventListener('click', (e: any) => {
              this.showImg = true;
              // eslint-disable-next-line prefer-destructuring
              this.imgSrc = e.currentTarget.src.split('?imageView')[0];
            });
          });
        }, 0);
      }

      this.$nextTick(() => {
        (this as any).$refs.content.scrollTop = (this as any).$refs.content.scrollHeight - this.scrollHeight;
        this.scrollHeight = (this as any).$refs.content.scrollHeight;
      });
    }
  }

  // 获取消息列表
  async getMessageList(isFlag: any | null) {
    const res = await this.tim.getMessageList({
      conversationID: this.conversationInfo.conversationID,
      count: 15
    });
    if (res && res.code === 0 && res.data) {
      // if (this.conversationInfo.conversationID === 'C2Cadmin' || this.conversationInfo.conversationID === 'C2CmallAdmin') {
      //   this.loading = false;
      //   const list = res.data.messageList[res.data.messageList.length - 1];
      //   this.isMoreMessage = true;
      //   this.messageList = this.formatList([list], 'push');
      //   (this as any).$refs.message.innerHTML = '';
      //   this.isOver = true;
      //   // setTimeout(() => {
      //   //   this.tim.logout();
      //   // }, 2000);
      //   return;
      // }
      this.isOver = false;
      // eslint-disable-next-line radix
      this.nextReqMessageID = res.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段
      this.isMoreMessage = !res.data.isCompleted; // 表示是否已经拉完所有消息
      if (res.data.messageList.length > 0) {
        this.messageList = this.formatList(res.data.messageList, 'push');
        this.$forceUpdate();
      }
      if (isFlag) {
        this.messageList.push({
          payload: { text: '会话转接成功' },
          flow: 'status'
        });
      }
      // if (this.robotObj.type === -1 && !this.changeIm) {
      //   this.messageList.push(this.robotObj);
      // }
      this.$nextTick(() => {
        setTimeout(() => {
          // eslint-disable-next-line no-unused-vars
          const tempDom: any | null = document.querySelector('.im-content');
          tempDom.scrollTop = tempDom.scrollHeight + tempDom.clientHeight; // 滚动条位置设置在底部
        }, 301);
      });
      // this.currentLen = this.messageList.length;
      this.messageList.push({
        payload: { text: '' },
        type: 'isGoods'
      });
      this.currentPage += 1;
      setTimeout(() => {
        const timPics = document.querySelectorAll('.tim-pic');
        timPics.forEach((element: any) => {
          if (element.getAttribute('islazy') === '1') {
            element.setAttribute('src', element.getAttribute('z-src'));
          }
          element.addEventListener('click', (e: any) => {
            this.showImg = true;
            // eslint-disable-next-line prefer-destructuring
            this.imgSrc = e.currentTarget.src.split('?imageView')[0];
          });
        });
      }, 0);
      this.tim.setMessageRead({
        conversationID: this.conversationInfo.conversationID
      }); // 设置已读
    }
  }

  // // 获取消息列表
  // async getMessageList() {
  //   const res = await this.tim.getMessageList({
  //     conversationID: this.conversationInfo.conversationID,
  //     count: 15
  //   });
  //   if (res && res.code === 0 && res.data) {
  //     this.nextReqMessageID = res.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段
  //     this.isMoreMessage = !res.data.isCompleted; // 表示是否已经拉完所有消息
  //     this.messageList = res.data.messageList.map((item: any) => {
  //       const data = item;
  //       if (data.type === 'TIMCustomElem') {
  //         const text = JSON.parse(data.payload.data).itemText;
  //         data.payload = { text };
  //         data.flow = 'status';
  //       }
  //       return data;
  //     });
  //     // utf16toEntities(item.lastMessage.messageForShow).replace(reg, `<img src="${this.emojiList[i].src}">`)
  //     // this.messageList = this.formatList(res.data.messageList, 'push'); // 获取当前消息列表
  //     this.tim.setMessageRead({
  //       conversationID: this.conversationInfo.conversationID
  //     }); // 设置已读
  //   }
  // }

  // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
  CONVERSATION_LIST_UPDATED(event: any) {
    // if (this.ready && event.data.length > 0) {
    //   this.conversationList = event.data; // 获取所有会话列表
    //   this.ready = false;
    // }
    const data = event.data[0];
    // eslint-disable-next-line no-shadow
    this.conversationInfo = data;
    setTimeout(async () => {
      if (
        data
        && data.lastMessage
        && data.lastMessage.payload.data
        && (JSON.parse(data.lastMessage.payload.data).itemType === 1
          || JSON.parse(data.lastMessage.payload.data).itemType === 0)
      ) {
        // const temp : any = JSON.parse(data.lastMessage.payload.data);
        // this.messageList.push({
        //   flow: 'in',
        //   payload: { text: temp.itemData.itemValue }
        // });
      } else if (
        data
        && data.lastMessage
        && data.lastMessage.payload.data
        && JSON.parse(data.lastMessage.payload.data).itemType !== 4
        && JSON.parse(data.lastMessage.payload.data).itemType !== 5
      ) {
        // await this.getMessageList(false, false);
        const mes: any = event.data[0];
        if (mes.lastMessage.payload.data) {
          if (this.currentId === JSON.parse(data.lastMessage.payload.data).itemType) {
            return;
          }
          this.currentId = JSON.parse(data.lastMessage.payload.data).itemType;
          // eslint-disable-next-line prefer-destructuring

          const temp = JSON.parse(mes.lastMessage.payload.data);
          temp.payload = { text: temp.itemText };
          temp.flow = 'status';
          if (this.messageList.length > 0) {
            if (this.newTime === temp.time) {
              return;
            }
            this.messageList = [];
            this.messageList.push(temp);
          } else if (JSON.parse(data.lastMessage.payload.data).itemType === 7) {
            this.messageList.push(temp);
          }
        }

        this.currentPage = 0;
        this.isOver = true;
        setTimeout(() => {
          this.currentId = -1;
        }, 1000);
        // this.getMessageList();
      } else {
        // if (this.currentPage === 0 && event.data[0].conversationID !== 'C2Cadmin') {
        //   // eslint-disable-next-line prefer-destructuring
        //   this.conversationInfo = event.data[0];
        //   await this.getCusterInfo();
        //   // alert('1');
        //   await this.getMessageList(true, false);
        //   const goods: any = {};
        //   goods.flow = 'consult';
        //   goods.payload = Object.assign({}, this.productInfo);
        //   this.messageList.push(goods);
        // }
        // eslint-disable-next-line no-lonely-if
        if (
          data
          && data.lastMessage
          && data.lastMessage.payload.data
          && JSON.parse(data.lastMessage.payload.data).itemType === 6
        ) {
          this.isOver = true;
        } else {
          this.isOver = false;
        }
      }
    }, 0);
  }
  // CONVERSATION_LIST_UPDATED(event : any) {
  //   const robot = event.data.filter((e: any) => e.conversationID === 'C2Cadmin');
  //   // if (robot.length === 1) this.robot = JSON.parse(robot[0].lastMessage.payload.data);
  //   // eslint-disable-next-line prefer-destructuring
  //   // if (event.data[0].conversationID !== 'C2Cadmin') this.conversationInfo = event.data[0];
  //   // // eslint-disable-next-line prefer-destructuring
  //   // else this.conversationInfo = event.data[1];
  //   // eslint-disable-next-line prefer-destructuring
  //   setTimeout(() => {
  //     if (robot[0].lastMessage.payload.data && JSON.parse(robot[0].lastMessage.payload.data).itemType !== 4 && JSON.parse(robot[0].lastMessage.payload.data).itemType !== 5) {
  //       // eslint-disable-next-line prefer-destructuring
  //       this.conversationInfo = robot[0];
  //       this.getMessageList();
  //       this.isOver = true;
  //     // this.getMessageList();
  //     } else {
  //       validateStatus({}).then((res : any) => {
  //         this.conversationInfo = {
  //           conversationID: `C2C${res.data.data.custAccount}`,
  //           userProfile: { userID: res.data.data.custAccount }
  //         };
  //         this.getCusterInfo();
  //         if (this.currentPage === 0) { this.getMessageList(); }
  //       });
  //       // alert(123);
  //       // validateStatus({}).then((res : any) => {
  //       //   this.conversationInfo = {
  //       //     conversationID: `C2C${res.data.data.custAccount}`,
  //       //     userProfile: { userID: res.data.data.custAccount }
  //       //   };
  //       //   this.getMessageList();

  //       // });
  //       this.isOver = false;
  //     }
  //   }, 100);
  // }

  // CONVERSATION_LIST_UPDATED(event: any) {
  //   if (event.data[0].lastMessage.payload.data && JSON.parse(event.data[0].lastMessage.payload.data).itemType === 7) {
  //     this.custerInfo.tempName = event.data[0].userProfile.nick;
  //     this.messageList.push({ type: 'TIMCustomElem', payload: { text: JSON.parse(event.data[0].lastMessage.payload.data).itemText }, flow: 'in' });
  //     this.isOver = false;
  //     return;
  //     // this.outLogin();
  //     // eslint-disable-next-line no-param-reassign
  //   }
  //   this.isOver = true;

  //   // else if (event.data[0].lastMessage.payload.data && JSON.parse(event.data[0].lastMessage.payload.data).itemType === 6) {
  //   //   this.messageList.push({ type: 'TIMCustomElem', payload: { text: JSON.parse(event.data[0].lastMessage.payload.data).itemText }, flow: 'status' });
  //   //   // eslint-disable-next-line no-param-reassign
  //   // }
  //   const robot = event.data.filter((e: any) => e.conversationID === 'C2Cadmin');
  //   if (robot.length === 1) {
  //     this.robot = JSON.parse(robot[0].lastMessage.payload.data);
  //   }
  //   if (event.data[0].conversationID !== 'C2Cadmin') {
  //     // eslint-disable-next-line prefer-destructuring
  //     this.conversationInfo = event.data[0];
  //   } else {
  //     // eslint-disable-next-line prefer-destructuring
  //     this.conversationInfo = event.data[1];
  //   }
  // }

  // // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
  // CONVERSATION_LIST_UPDATED(event : any) {
  //   const robot = event.data.filter((e: any) => e.conversationID === 'C2Cadmin');
  //   if (robot.length === 1) this.robot = JSON.parse(robot[0].lastMessage.payload.data);
  //   // eslint-disable-next-line prefer-destructuring
  //   if (event.data[0].conversationID !== 'C2Cadmin') { this.conversationInfo = event.data[0]; } else this.conversationInfo = event.data[1];

  // }
  // 账号导入
  private async outLogin() {
    const promise = this.tim.logout();
    await promise.then(() => {}).catch(() => {});
  }

  private async getImportAccount() {
    const anchor = readCookie('anchor');
    const res: any = await importAccount({
      headImgType: anchor ? '5_im' : '7_im',
      companyId: 1,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : ''
    });
    this.userInfo = res.data.data;
    this.getValidateStatus();
  }

  // 将dom对象转换成字符串
  nodeToString(node: any) {
    // createElement()返回一个Element对象
    const tmpNode = document.createElement('div');
    // appendChild()  参数Node对象   返回Node对象  Element方法
    // cloneNode()  参数布尔类型  返回Node对象   Element方法
    tmpNode.appendChild(node.cloneNode(true));
    const str = tmpNode.innerHTML;
    return str;
  }

  // 会话状态
  async sessionState() {
    const state: any = await validateInputStatus({ companyId: 1 });
    if (state && state.code === 100 && state.data && state.data.data.messageStatus) {
      return true;
    }
    const promise = this.tim.deleteConversation(this.conversationInfo.conversationID);
    promise.then(() => {
      // (this as any).$toast.text('当前会话已结束');
      this.$message.error('当前会话已结束');
      this.isOver = true;
    });
    return false;
  }

  // // 发送消息
  // sendMessage() {
  //   // 1. 创建消息实例，接口返回的实例可以上屏
  //   const lastTime = this.messageList.length >= 1 ? this.messageList[this.messageList.length - 1].time : 0; // 最后一条消息的时间
  //   const d: any = new Date();
  //   const date: any = Date.parse(d) / 1000;
  //   // eslint-disable-next-line radix
  //   const realTime = parseInt(date);
  //   // 时间大于5分钟则验证会话状态
  //   if ((realTime - lastTime) >= 300) {
  //     const state = this.sessionState();
  //     if (!state) return;
  //   }
  //   this.message = (this.$refs.message as any).innerHTML;
  //   if (this.message.indexOf('data-src="emoji"') !== -1) {
  //     for (let i = 0; i < this.emojis.length; i += 1) {
  //       if (this.message.indexOf(`${this.emojis[i].text}`) !== -1) {
  //         const dom = (this.$refs.message as any).querySelector(`img[emoji-text=${this.emojis[i].text}]`);

  //         // (this.$refs.message as any).removeChild(dom);
  //         // const regImg = new RegExp(`<img class="emoji-img" emoji-src="${this.emojis[i].src}" data-src="emoji">`, 'g');
  //         this.message = this.message.replace(this.nodeToString(dom), uncodeUtf16(this.emojis[i].code));
  //         if (this.message.indexOf('data-src="emoji"') === -1) break;
  //       }
  //     }
  //   }
  //   const initMessage = this.tim.createTextMessage({
  //     to: this.conversationInfo.userProfile.userID,
  //     conversationType: TIM.TYPES.CONV_C2C,
  //     // payload: {
  //     //   text: `json=${JSON.stringify({
  //     //     name: '输入佳博P3热敏不干胶条码打印机佳博',
  //     //     url: 'https://6d84-shanghai-007-shared-09-1256635546.cos.ap-shanghai.myqcloud.com/a6ec-1400428151/4353-mall_im_96295/mall_im_96295-CT002-2523-logo.png',
  //     //     price: 11.22
  //     //   })}`
  //     // }
  //     payload: { text: this.message }
  //   });
  //   // 2. 发送消息
  //   const promise = this.tim.sendMessage(initMessage);
  //   promise
  //     .then((imResponse: any) => {
  //       this.messageList.push(imResponse.data.message); // 更新消息列表
  //     })
  //     .catch((imError: any) => {
  //     }); // 发送失败
  // }

  // 发送文字或表情消息
  async sendMessage() {
    if (this.isOver) {
      return;
    }
    // const lastTime = this.messageList.length >= 1
    //   ? this.messageList[this.messageList.length - 1].time
    //   : 0; // 最后一条消息的时间
    // const d: any = new Date();
    // const date: any = Date.parse(d) / 1000;
    // eslint-disable-next-line radix
    // const realTime = parseInt(date);
    // 时间大于5分钟则验证会话状态

    const reg = /\S/g;
    if (!reg.test((this as any).$refs.message.innerHTML.replace('<br>', ''))) {
      (this as any).$refs.message.focus();
      (this as any).$toast.text('不能发送空白消息');
      return;
    }
    // if (realTime - lastTime >= 300) {
    //   const state = await this.sessionState();
    //   if (!state) return;
    // }

    const mes = (this as any).$refs.message.innerHTML.replace(/\n/g, '<br>');
    // 表情解码发送
    this.message = (this as any).$refs.message.innerHTML.replace(/\n/g, '<br>');
    if (this.message.indexOf('data-src="emoji"') !== -1) {
      for (let i = 0; i < this.emojis.length; i += 1) {
        if (this.message.indexOf(`${this.emojis[i].src}`) !== -1) {
          const doms = (this.$refs.message as any).querySelectorAll(
            `img[emoji-text=${this.emojis[i].text}]`
          );
          // (this.$refs.message as any).removeChild(dom);
          // const regImg = new RegExp(`<img class="emoji-img" emoji-src="${this.emojis[i].src}" data-src="emoji">`, 'g');
          doms.forEach((element: any) => {
            this.message = this.message.replace(
              this.nodeToString(element),
              uncodeUtf16(this.emojis[i].code)
            );
          });
          if (this.message.indexOf('data-src="emoji"') === -1) break;
        }
      }
    }
    (this as any).$refs.message.innerHTML = '';
    // 1. 创建消息实例，接口返回的实例可以上屏
    const initMessage = this.tim.createTextMessage({
      to: this.conversationInfo.userProfile.userID,
      conversationType: TIM.TYPES.CONV_C2C,
      payload: { text: this.message }
    });
    // 2. 发送消息
    const promise = this.tim.sendMessage(initMessage);
    promise
      .then((imResponse: any) => {
        // eslint-disable-next-line no-param-reassign
        imResponse.data.message.payload.text = mes;
        this.messageList.push(imResponse.data.message); // 更新消息列表
        this.message = '';
        this.$nextTick(() => {
          (this as any).$refs.content.scrollTop = (this as any).$refs.content.scrollHeight - (this as any).$refs.content.clientHeight; // 滚动条位置设置在底部
        });
      })
      .catch(() => {}); // 发送失败
  }

  private async getImData() {
    this.getValidateStatus();
  }

  private async getValidateStatus() {
    // const res: any = await validateStatus({});
    // if (res.data.data.messageStatus && this.isOnce === 0) {
    //   this.isOnce += 1;
    //   await indexLoad({});
    //   this.getValidateStatus();
    //   return;
    // }
    // this.conversationInfo = {
    //   conversationID: `C2C${res.data.data.custAccount}`,
    //   userProfile: { userID: res.data.data.custAccount }
    // };
    // this.getCusterInfo();

    this.tim = await this.initTim();
    // this.outLogin();
    const promise = this.tim.login({
      userID: this.userInfo.account,
      userSig: this.userInfo.userSign
    });
    promise
      .then((imResponse: any) => {
        if (imResponse.data.repeatLogin === true) {
          // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
          this.ready = false;
          this.SDK_READY();
        }
      })
      .catch(() => {});
    // this.getImportAccount();
    // this.getHistory();
  }
}
